import { Link, Button, Header } from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import { useOAuth2Clients } from "@sso/oauth2-clients/hooks";
import { IOAuth2Client } from "@sso/oauth2-clients/contracts";
import { useMemo } from "react";
import { Column } from "react-table";
import { useHistory } from "react-router-dom";
import FormattedDuration from "react-intl-formatted-duration";
import { DefaultColumnFilter, GridView } from "@funcional/react-table-ui";

export default function ListOauth2ClientsInfoPage() {
  const history = useHistory();

  const showRecord = (row: any) =>
    history.push(`/sso/oauth2-clients/${row.original.id}`);

  const editRecord = (row: any) =>
    history.push(`/sso/oauth2-clients/${row.original.id}/edit`);

  const columns: Column<IOAuth2Client>[] = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Filter: DefaultColumnFilter,
      },
      {
        Header: "Nome",
        accessor: "name",
        Filter: DefaultColumnFilter,
      },
      {
        Header: "Tipo",
        accessor: "type",
      },
      {
        Header: "Duração do token",
        accessor: "tokenExpiration",
        Cell: ({ value }) => (
          <div title={value + " segundos"}>
            <FormattedDuration
              seconds={value}
              unitDisplay="short"
              format="{days} {hours} {minutes} {seconds}"
            />
          </div>
        ),
      },
      {
        Header: "Usuário",
        accessor: "user",
        Cell: ({ value }) =>
          value ? (
            <Link to={`/sso/users/${value.uuid}`}>{value.name}</Link>
          ) : (
            "-"
          ),
      },
    ],
    []
  );

  return (
    <>
      <Header
        title="Clientes de OAuth2"
        buttons={
          <Restricted to="create.programs">
            <div className="flex-shrink-0">
              <Button
                color="primary"
                onClick={() => history.push(`/sso/oauth2-clients/new`)}
              >
                Novo Cliente
              </Button>
            </div>
          </Restricted>
        }
      />

      <GridView<IOAuth2Client>
        accessControlResourceName="oauth2_clients"
        paginationType="page"
        columns={columns}
        hook={useOAuth2Clients}
        showRecord={showRecord}
        editRecord={editRecord}
        defaultFilters={[]}
      />
    </>
  );
}
